import { Directive } from '@angular/core';

@Directive({ selector: '[appEncounterTable]', standalone: true })
export class EncounterTableDirective {}
